import { render, staticRenderFns } from "./JobList.vue?vue&type=template&id=4160c572&scoped=true"
import script from "./JobList.vue?vue&type=script&lang=js"
export * from "./JobList.vue?vue&type=script&lang=js"
import style0 from "./JobList.vue?vue&type=style&index=0&id=4160c572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4160c572",
  null
  
)

export default component.exports